'use strict';

function newYear () {
  var moment = window.moment;
  if (typeof moment === 'undefined' || typeof moment.range === 'undefined') {
    return;
  }
  var startDate = new Date(2015, 11, 23);
  var endDate = new Date(2016, 0, 5);
  var period = moment.range(startDate, endDate);
  var newYearPeriod = period.contains(new Date());
  var $logo = $('#top .navbar-brand');

  if (!newYearPeriod) {
    return;
  }

  $logo.addClass('new-year-2015');

  $logo.on('mouseenter', function (event) {
    console.log('new year!');
  });
}

module.exports = newYear;
